/* Brand group for singles collections without the Brand-metafield filter (assets/monmouth-brand-counts.js)
   Used on /collections/new-single-cards, where Shopify ignores filter.p.m.custom.brand (collection too large).
   The sidebar renders the listed brands (settings.singles_brand_list) as tag options with hidden "(N)" slots and an
   "Other" row. This script:
     1. reads each brand's product count from the count-only template (templates/collection.shopcount.liquid),
     2. treats a tag as real only if 0 < count < collection total (Shopify ignores unknown tags in a path and returns
        EVERYTHING, which would otherwise show a bogus full count and an "OR" that matches every product),
     3. shows each real brand with its count (counts follow the other active tag filters), hides the rest,
     4. prunes the "Other" row to the brand tags that exist and sums their counts.
   The collection page swaps its filter HTML with innerHTML after each click, so a MutationObserver re-runs this. */
(function () {
  'use strict';
  if (window.__mcBrandCounts) return;
  window.__mcBrandCounts = true;

  var TTL = 600000, inflight = {};

  function hz(s) { return String(s).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function cget(k) { try { var c = JSON.parse(sessionStorage.getItem('mc_brand_' + k) || 'null'); if (c && Date.now() - c.t < TTL) return c.n; } catch (e) {} return null; }
  function cset(k, n) { try { sessionStorage.setItem('mc_brand_' + k, JSON.stringify({ n: n, t: Date.now() })); } catch (e) {} }

  function count(path) {
    var c = cget(path);
    if (c !== null) return Promise.resolve(c);
    if (inflight[path]) return inflight[path];
    inflight[path] = fetch(path + '?view=shopcount', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var n = parseInt(String(t).replace(/[^0-9]/g, ''), 10); if (isNaN(n)) n = null; if (n !== null) cset(path, n); delete inflight[path]; return n; })
      .catch(function () { delete inflight[path]; return null; });
    return inflight[path];
  }

  function fmt(n) { return '(' + n + ')'; }

  function run() {
    document.querySelectorAll('[data-brand-tags]').forEach(function (group) {
      if (group.getAttribute('data-brand-busy') === '1') return;
      var base = (group.getAttribute('data-brand-base') || '').replace(/\/$/, '');
      if (!base) return;
      var listed = Array.prototype.slice.call(group.querySelectorAll('[data-brand-opt]'));
      var other = group.querySelector('[data-brand-other]');
      var otherHandles = other ? (other.getAttribute('data-brand-other') || '').split(',').filter(Boolean) : [];
      var otherTags = other ? (other.getAttribute('data-brand-other-tags') || '').split('|') : [];
      var allHandles = listed.map(function (a) { return a.getAttribute('data-brand-opt'); }).concat(otherHandles);
      var brandSet = {}; allHandles.forEach(function (h) { brandSet[h] = true; });

      /* tags already active in the URL (path), minus brand tags → counts follow the other filters */
      var path = decodeURIComponent(location.pathname);
      var tail = path.indexOf(base) === 0 ? path.slice(base.length).replace(/^\//, '') : '';
      var ctx = tail ? tail.split('+').filter(function (t) { return t && !brandSet[hz(t)]; }) : [];
      var ctxPath = ctx.length ? base + '/' + ctx.join('+') : base;

      group.setAttribute('data-brand-busy', '1');
      count(base).then(function (total) {
        if (!total) { group.removeAttribute('data-brand-busy'); return; }
        var uniq = Object.keys(brandSet);
        return Promise.all(uniq.map(function (h) { return count(base + '/' + h); })).then(function (n0s) {
          var exists = {};
          uniq.forEach(function (h, i) { exists[h] = n0s[i] !== null && n0s[i] > 0 && n0s[i] < total; });
          var ctxCounts = {};
          if (!ctx.length) { uniq.forEach(function (h, i) { ctxCounts[h] = exists[h] ? n0s[i] : 0; }); return ctxCounts; }
          return Promise.all(uniq.map(function (h) { return exists[h] ? count(ctxPath + '+' + h) : Promise.resolve(0); })).then(function (ns) {
            uniq.forEach(function (h, i) { ctxCounts[h] = ns[i] || 0; });
            return ctxCounts;
          });
        }).then(function (counts) {
          var exists = {}; Object.keys(counts).forEach(function (h) { exists[h] = true; });
          listed.forEach(function (a) {
            var h = a.getAttribute('data-brand-opt'), n = counts[h] || 0;
            var sel = a.classList.contains('mc-sidebar__option--selected');
            var c = a.querySelector('[data-brand-count]'); if (c) c.textContent = n ? fmt(n) : '';
            a.style.display = (n > 0 || sel) ? '' : 'none';
          });
          if (other) {
            var ok = [], oktags = [], sum = 0;
            otherHandles.forEach(function (h, i) { if (counts[h] > 0) { ok.push(h); oktags.push(otherTags[i]); sum += counts[h]; } });
            other.setAttribute('data-tag', oktags.join('|'));
            var oc = other.querySelector('[data-brand-count]'); if (oc) oc.textContent = sum ? fmt(sum) : '';
            var osel = other.classList.contains('mc-sidebar__option--selected');
            other.style.display = (sum > 0 || osel) ? '' : 'none';
          }
          group.removeAttribute('data-brand-busy');
        });
      }).catch(function () { group.removeAttribute('data-brand-busy'); });
    });
  }

  var timer = null;
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; run(); }, 0); }
  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; added && j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-brand-tags') || n.querySelector('[data-brand-tags]'))) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
